import { useCurrentClientUserStore } from '@client/entity/current-client-user/application/store/current-client-user.store';
import type { RouteLocationRaw } from 'vue-router';

type CheckCurrentClientUserHasClientOptions = {
  redirectTo?: RouteLocationRaw;
};

export function checkCurrentClientUserHasClient(
  options: CheckCurrentClientUserHasClientOptions = {},
): true | false | RouteLocationRaw {
  const currentClientUserStore = useCurrentClientUserStore();

  return currentClientUserStore.definedCurrentClientUser.clients.length ? true : (options.redirectTo ?? false);
}
